import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Amount extends DesigntimeComponent {
    static staticName = "Amount";
    static staticId = "amount";

    runtimeAmount;

    constructor(identifyer) {
        super(identifyer, 1);

        this.runtimeAmount = 0;
        this.disableNextButton();

        this.values = {
            header: { value: "Header" },
            description: { value: "I have" },
            currency: { value: "kr" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {

        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView();

        var $view = $("<div></div>");
        $view.append("<h3>" + this.values.header.value + "</h3>")

        $view.append($(`<p>${this.values.description.value}</p>`));

        var $amount = $("<input class='sid-component-input-number'type='number'></input>");
        $amount.on('input', function (e) {
            this.runtimeAmount = $(e.currentTarget).val();
            this.openNextButton();
        }.bind(this));

        $view.append($amount);
        $view.append($("<label>" + this.values.currency.value + "</label>"));

        return $view;
    }

    getRuntimeBootstrapView() {
        var $view = $("<div class='mb-4 content-amount'></div>");
        $view.append("<h3>" + this.values.header.value + "</h3>")

        $view.append($(`<p>${this.values.description.value}</p>`));

        var $amount = $(`<input type='number' class='form-control text-center'></input>`);
        $amount.on('input', function (e) {
            this.runtimeAmount = $(e.currentTarget).val();
            this.openNextButton();
        }.bind(this));

        let $inputGroup = $(`<div class='input-group'></div>`);
        let $currency = $(`<div class='input-group-text'>${this.values.currency.value}</div>`);
        $inputGroup.append($amount);
        $inputGroup.append($currency);
        $view.append($inputGroup);

        return $view;
    }

    openNextButton() {
        if (this.runtimeAmount) {
            this.enableNextButton();
        } else {
            this.disableNextButton();
        }
    }

    output = [{ name: "amount", type: "number" }];

    getOutput() {
        return {
            amount: this.runtimeAmount,
        };
    }
}

export { Amount }
